import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import messages from '../../../services/messages'
import { objLength } from '../../../utils/customMethods'
import {
  setInsight,
  resetInsightsStatus,
} from '../../../redux/insights/actions'

const InsightsEngine = ({ payload }) => {
  const dispatch = useDispatch()

  const features = useSelector((state) => state.features)
  const feature = features?.find((e) => e.name === 'Insight')
  const insights = useSelector((state) => state?.insights)

  const isFeatureActive = feature?.active
  const regexList = feature?.config?.list?.map(
    (e) => e.active && { id: e.id, name: e.name, regex: e.regex }
  )

  const testRegex = (message) => {
    let result = null
    regexList.forEach((element) => {
      try {
        const str = element.regex
        const expReg = new RegExp(
          str.match('(?<=/)(.*)(?=/)')[0], // This get all between two "/" (regex)
          str.substr(str.lastIndexOf('/') + 1, str.lenght) // This get all after last "/" (flags)
        )
        result = {
          id: element.id,
          name: element.name,
          value: message.match(expReg)[0],
        }
      } catch (error) {
        //Invalid Expression or Message Not Match
      }
    })
    return result
  }

  const processInsights = (data) => {
    try {
      data?.message.forEach((element) => {
        if (regexList) {
          const insight = testRegex(element?.text)
          if (insight) {
            const newFields = {
              conversation_id: data?.conversationId,
              message_current_id: element?.currentId,
              insight_id: insight?.id,
              name: insight?.name,
              text: insight?.value,
            }
            handleSubmit(newFields)
          }
        }
      })
    } catch (error) {}
  }

  const handleSubmit = async (newFields) => {
    if (objLength(newFields) > 0) {
      try {
        const { name, ...rest } = newFields
        const response = await messages.post(
          `/tech4h-messages/conversation/insights`,
          { ...rest }
        )

        if (response.status === 200) {
          const obj = {
            chatId: newFields?.conversation_id,
            data: {
              cat: newFields?.name,
              value: newFields?.text,
            },
          }
          dispatch(setInsight(obj))
        } else {
          throw response.data
        }
      } catch (error) {
        let message =
          error?.response?.status === 500
            ? 'Unavailable service'
            : error?.response?.data?.message
        console.error('insights error', message)
      }
    }
  }

  useEffect(() => {
    if (payload && isFeatureActive) {
      processInsights(payload)
    }
  }, [payload])

  useEffect(() => {
    if (insights?.status?.set_insight?.success) {
      dispatch(resetInsightsStatus('set_insight'))
    }
  }, [insights])

  return null
}

export default InsightsEngine
